import React from 'react';
import { cn } from '@/lib/utils';

interface WorkspaceLayoutProps {
  /** Optional sticky header (e.g. ReportsContextHeader). */
  header?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

/**
 * Shell layout for workspace pages: optional header + main content.
 * Ensures context header is always visible when provided.
 */
export const WorkspaceLayout: React.FC<WorkspaceLayoutProps> = ({
  header,
  children,
  className,
}) => {
  return (
    <div
      className={cn('flex flex-col h-full min-h-0 w-full', className)}
      data-testid="workspace-layout"
    >
      {header != null && <>{header}</>}
      <main className="flex-1 flex flex-col min-h-0 min-w-0 overflow-hidden">
        {children}
      </main>
    </div>
  );
};
